export default {"src":"/_next/static/media/separator-bottom.05a5390c.svg","height":61,"width":1200,"blurWidth":0,"blurHeight":0};